module.exports = __webpack_public_path__ + "img/imgentrew4.710c9387.png";